<template>
  <v-dialog
    @input="$emit('update')"
    :value="visible"
    width="500"
  >
    <v-card>
      <v-card-title
        class="headline grey lighten-2"
        primary-title
      >
        Aufnahmeschreiben
      </v-card-title>

      <v-card-text>
          <p>An die neu in den Verein eingetretenen Mitglieder </p>

          <p>Damit Sie und Ihr Kind sich künftig bei uns wohlfühlen und über die notwendigen
            Informationen verfügen, erhalten Sie hiermit einige Ansprechpartner. Sie können sich an
            sie wenden, wenn bei Ihnen Fragen entstehen oder Sie sich nicht ausreichend informiert
            sehen.</p>
          <p>Elternansprechpartner:<br>
          Christopher Greenaway, Tel. 0160 – 92 76 99 71<br>

          <p>Vorstandsmitglieder:<br>
          Abteilungsleiter Roland Hocker<br>
          Finanzen und Schriftführerin Regina Paulus<br>
          Beisitzer Christine Maier<br>
          Beisitzer Christopher Greenaway<br>
          Beisitzer Mario Cicvaric<br>
          Kontakthandy Vorstand: 0152 – 24 47 13 01, mail@tec-stuttgart.de</p>

          <p>Aktuelle Information halten wir für Sie auf unserer Homepage unter www.tec-stuttgart.de
            bereit. Änderungen des Trainingsplans, die sich auch kurzfristig ergeben können, finden
            Sie direkt auf der Startseite - weitergehende Informationen in den entsprechenden
            Rubriken. Per Mail erreichen Sie uns unter mail@tec-stuttgart.de.<br>
            Bitte beachten Sie, dass alle Vereinsfunktionäre ehrenamtlich in ihrer Freizeit tätig
            sind. Wir alle sind bemüht, Ihnen notwendige Informationen zeitnah zukommen zu
            lassen.<br>
            Trotzdem kommt es auch darauf an, dass Sie sich aktiv um Ihre Belange kümmern.<br>
            Alle unsere Trainer stehen Ihnen auch für Privatstunden zur Verfügung, in denen Ihr Kind
            individuell betreut und gezielter unterrichtet wird, als dies in den
            Vereinstrainingsstunden möglich ist.<br>
            Wir haben als Verein den Anspruch alle Kinder gemäß ihrer Begabung zu fördern.<br>
            Wie schnell ihr Kind lernt hängt von vielen Faktoren ab - zu Beginn des Eislaufens vor
            allem auch von der Häufigkeit der Trainingseinheiten. Unsere Trainer und Übungsleiter
            beraten Sie gerne, welche und wie viele Trainingseinheiten für ihr Kind sinnvoll
            sind.<br>
            Beachten Sie, dass Eiskunstlauftrainer während des Trainingsbetriebs kaum Zeit für
            längere Gespräche haben. Die Pausen zwischen den einzelnen Zeiten reichen höchstens für
            kurze Rücksprachen. Für Beratungen vereinbaren Sie bitte separate Gesprächstermine.</p>

          <p>Wir wünschen Ihnen und Ihrem Kind eine gute Zeit in unserem Verein.</p>
      </v-card-text>

      <v-divider></v-divider>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          flat
          @click="$emit('update')"
        >
          I accept
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    name: "Aufnahmeschreiben",
    props: {
      visible: {
        type: Boolean,
        required:true
      },
    },
  }
</script>

